// eslint-disable-next-line
export default (value: number): boolean => value % 2 === 0;
